import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { BankingReportService } from '../../services/banking-report.service';

@Component({
  selector: 'split-withdrawal-balance',
  templateUrl: './split-withdrawal-balance.component.html',
  styleUrls: ['./split-withdrawal-balance.component.scss']
})
export class SplitWithdrawalBalanceComponent implements OnChanges {

  @Input() recipient: string = '';
  @Output() onAvailableWithdrawalChanges = new EventEmitter<number>();

  toBeLiquidated = 0;
  availableForWithdrawal= 0;

  constructor(private bankingReportService: BankingReportService) {}

  ngOnChanges(): void {
    if(this.recipient != '') {
      this.loadBalance();
    }
  }

  loadBalance() {
    this.bankingReportService.getReportBalance(this.recipient)
      .subscribe((res: any) => {
        this.availableForWithdrawal = res.availableAmount;
        this.toBeLiquidated = res.waitingFundsAmount;
        this.onAvailableWithdrawalChanges.emit(this.availableForWithdrawal);
    }) 
  }

}
